// userContextManager.ts - Create a singleton to manage the user context

let userContextInstance: any = null;
let fetchingContext = false;
let contextPromise: Promise<any> | null = null;

/**
 * Get the user context, only fetching it once
 * @returns Promise resolving to the current user context
 */
export const getUserContext = async (): Promise<any> => {

    // If we already have a context, return it immediately
    if (userContextInstance) {
        return userContextInstance;
    }

    // If we're already fetching the context, wait for that promise
    if (fetchingContext && contextPromise) {
        return contextPromise;
    }

    // Otherwise, fetch it for the first time
    fetchingContext = true;

    // Create a promise that will resolve when context is fetched
    contextPromise = new Promise(async (resolve, reject) => {
        try {
            // Import your auth utilities
            const { fetchUserContext } = await import('../utils/AuthenticationUtils');

            const context = await fetchUserContext();

            // Store it for future use
            userContextInstance = context;
            fetchingContext = false;

            resolve(context);
        } catch (error) {
            fetchingContext = false;
            reject(error);
        }
    });

    return contextPromise;
};

/**
 * Clear the cached user context, forcing a refresh on next request
 */
export const clearUserContext = () => {
    userContextInstance = null;
    fetchingContext = false;
    contextPromise = null;
};